import { LocalStorage } from '../../tokens';

export const LOCAL_STORAGE_VALUES = {
  'tpci-id-youlend': localStorage.getItem(LocalStorage.TPCI_ID_YOULEND),
};
